import { isAxiosError } from 'axios';

export type ApiErrorSection = {
  title?: string;
  messages: string[];
};

function messagesFrom(value: unknown): string[] {
  if (typeof value === 'string') {
    return value ? [value] : [];
  }
  if (!value || typeof value !== 'object') {
    return [];
  }
  return Object.values(value as Record<string, string>).filter(Boolean);
}

export function parseApiErrors(errorOrErrors?: unknown): ApiErrorSection[] {
  const errors = isAxiosError(errorOrErrors)
    ? errorOrErrors.response?.data?.errors
    : errorOrErrors;

  if (!errors || typeof errors !== 'object') {
    return [];
  }

  const sections: ApiErrorSection[] = [];

  for (const [key, value] of Object.entries(
    errors as Record<string, unknown>
  )) {
    if (key === 'items') {
      if (typeof value === 'string') {
        sections.push({ messages: [value] });
        continue;
      }
      if (value && typeof value === 'object') {
        for (const [index, item] of Object.entries(
          value as Record<string, unknown>
        )) {
          const messages = messagesFrom(item);
          if (!messages.length) continue;
          const n = Number(index);
          sections.push({
            title: `Line item ${Number.isFinite(n) ? n + 1 : index}`,
            messages,
          });
        }
      }
      continue;
    }

    const messages = messagesFrom(value);
    if (messages.length) {
      sections.push({ messages });
    }
  }

  return sections;
}
